import React, { useState } from 'react';
export function TransformationSlider() {
  const [sliderPos, setSliderPos] = useState(50);
  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSliderPos(Number(e.target.value));
  };
  return <section className="py-24 px-6 bg-white border-y-3 border-charcoal" data-id="element-210">
      <div className="max-w-7xl mx-auto" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-213">
            The Power of Refacing
          </h2>
          <p className="text-charcoal/60 max-w-2xl mx-auto" data-id="element-214">
            See how we transform outdated oak into modern espresso luxury in
            just 48 hours.
          </p>
        </div>

        <div className="relative aspect-[4/3] md:aspect-[21/9] w-full overflow-hidden border-3 border-charcoal select-none bg-charcoal" data-id="element-215">
          {/* Before Image (Bottom Layer) */}
          <div className="absolute inset-0" data-id="element-216">
            <img src="https://cdn.magicpatterns.com/uploads/qpDX6qPp5GrQW1uriJgv33/image.png" alt="Before Refacing" className="w-full h-full object-cover brightness-[0.9]" data-id="element-217" />
            <div className="absolute bottom-8 left-8 bg-charcoal text-alabaster px-6 py-2 font-bold uppercase tracking-widest text-sm z-0" data-id="element-218">
              Before: Outdated Oak
            </div>
          </div>

          {/* After Image (Top Layer, Clipped) */}
          <div className="absolute inset-0 border-r-4 border-white z-10" style={{
          width: `${sliderPos}%`
        }} data-id="element-219">
            <div className="absolute inset-0 w-[100vw] md:w-[80vw] lg:w-[1280px]" data-id="element-220">
              <img src="https://cdn.magicpatterns.com/uploads/uyAyGkhhVAJn3hZ2c4Gr3n/image.png" alt="After Refacing" className="w-full h-full object-cover" data-id="element-221" />
            </div>
            <div className="absolute bottom-8 left-8 bg-espresso text-alabaster px-6 py-2 font-bold uppercase tracking-widest text-sm whitespace-nowrap" data-id="element-222">
              After: Modern White Reface
            </div>
          </div>

          {/* Slider Input */}
          <input type="range" min="0" max="100" value={sliderPos} onChange={handleSliderChange} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-20" data-id="element-223" />

          {/* Visual Handle */}
          <div className="absolute top-0 bottom-0 w-1 bg-white z-10 pointer-events-none" style={{
          left: `${sliderPos}%`
        }} data-id="element-224">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-espresso rounded-full border-4 border-white flex items-center justify-center shadow-xl" data-id="element-225">
              <div className="flex gap-1" data-id="element-226">
                <div className="w-1 h-4 bg-white/40 rounded-full" data-id="element-227" />
                <div className="w-1 h-4 bg-white/40 rounded-full" data-id="element-228" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}